package com.gsb.vyapar.bhagya.presentation.navigation.view

import androidx.compose.foundation.layout.RowScope
import androidx.compose.material.BottomNavigationItem
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.navigation.NavHostController
import androidx.navigation.compose.currentBackStackEntryAsState
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.Screens.*
import com.gsb.vyapar.bhagya.presentation.common.icon.BottomBarIcon
import com.gsb.vyapar.bhagya.presentation.common.text.*
import com.gsb.vyapar.bhagya.theme.*
import org.jetbrains.compose.resources.DrawableResource

@Composable
fun RowScope.NavigationItem(screen: Screens, navController: NavHostController) {
    val navBackStackEntry by navController.currentBackStackEntryAsState()
    val currentRoute = navBackStackEntry?.destination?.route
    BottomNavigationItem(selectedContentColor = white,
        unselectedContentColor = hintColor,
        icon = { BottomBarIcon(res = getNavIcon(screen)) },
        label = { Text11Regular(screen.toString(), if (currentRoute == screen.toString()) white else unselected) },
        selected = currentRoute == screen.toString(),
        onClick = {
            navController.navigate(screen.toString()) {
                navController.graph.startDestinationRoute?.let { route ->
                    popUpTo(route) {
                        saveState = true
                    }
                }
                launchSingleTop = true
                restoreState = true
            }
        }
    )
}

fun getNavIcon(screen: Screens): DrawableResource {
    return when(screen) {
        Categories -> category
        Latest -> latest
        Favorites -> favorites
        else -> { home }
    }
}
